/* eslint-disable class-methods-use-this */
import { render } from "react-dom";
import React from "react";
import log from "./log";
import PlayedGames from "../components/playedgames.jsx";

const PLAYTIME_HEARTBEAT_SECONDS = 30;

class GamesPlayedHelper {
    constructor() {
        this.sentplayed = false;
        this.sentextra = false;
        this.isInTab = false;
        this.hasBeenInTab = false;
        this.screenExited = false;

        this.playtimeSeconds = 0;
        this.playtimeSent = 0;
        this.playtimeTickHandle = null;

        this.migrate = this.migrate.bind(this);
        this.load = this.load.bind(this);
        this.pike = this.pike.bind(this);
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
        this.add_played_extra = this.add_played_extra.bind(this);
        this.startPlaytimeTracking = this.startPlaytimeTracking.bind(this);
        this.stopPlaytimeTracking = this.stopPlaytimeTracking.bind(this);
        this.handlePlaytimeVisibilityChange = this.handlePlaytimeVisibilityChange.bind(this);
        this.flushPlaytime = this.flushPlaytime.bind(this);
    }

    migrate() {
        if (typeof Cookies.getJSON("games_played") !== "undefined") {
            localStorage.setItem(
                "games_played",
                JSON.stringify(Cookies.getJSON("games_played")),
            );
            Cookies.remove("games_played");
        }
    }

    load() {
        try {
            window.played = JSON.parse(localStorage.getItem("games_played"));
        } catch (e) {}
        if (window.played === null) {
            window.played = [];
        }
        try {
            window.played_session = JSON.parse(
                sessionStorage.getItem("games_played"),
            );
        } catch (e) {}
        if (window.played_session === null) {
            window.played_session = [];
        }
    }

    storeOnLocalStorage(store) {
        let flag = false;
        for (const data of window.played) {
            if (data.id == gameSettings.gameInfo.id) {
                flag = true;
            }
        }
        if (!flag) {
            window.played.unshift(gameSettings.gameInfo);
        }

        if (window.played.length >= 10) {
            window.played.length = 10;
        }
        try {
            localStorage.setItem("games_played", JSON.stringify(window.played));
        } catch (error) {
            console.log("Local Storage not Supported or Permission Denied");
        }
    }

    storeOnSessionStorage() {
        let flag = false;
        for (const data of window.played_session) {
            if (data.id == gameSettings.gameInfo.id) {
                flag = true;
            }
        }
        if (!flag) {
            window.played_session.unshift(gameSettings.gameInfo);
        }
        try {
            sessionStorage.setItem(
                "games_played",
                JSON.stringify(window.played_session),
            );
        } catch (error) {
            console.log("Session Storage not Supported or Permission Denied");
        }
    }

    pike() {
        this.startPlaytimeTracking();

        if (this.sentplayed) {
            return;
        }
        log(__filename, "Registering game has played");
        $.ajax({
            url: links.api.games_played
                .replace("_SK_", window.session_key)
                .replace("_ID_", gameSettings.gameInfo.id),
            cache: false,
        }).done((_) => {
            this.storeOnLocalStorage();
            this.storeOnSessionStorage();

            // Check visibility Setup
            let hidden;
            let visibilityChange;
            if (typeof document.hidden !== "undefined") {
                // Opera 12.10 and Firefox 18 and later support
                hidden = "hidden";
                visibilityChange = "visibilitychange";
            } else if (typeof document.msHidden !== "undefined") {
                hidden = "msHidden";
                visibilityChange = "msvisibilitychange";
            } else if (typeof document.webkitHidden !== "undefined") {
                hidden = "webkitHidden";
                visibilityChange = "webkitvisibilitychange";
            }

            if (
                typeof document.addEventListener === "undefined"
                || typeof document.hidden === "undefined"
            ) {
                log(
                    __filename,
                    "Browser doesn't support eventListener or hidden detection ",
                    "info",
                );
                this.isInTab = true;

                this.hasBeenInTab = true;
            } else {
                document.addEventListener(
                    visibilityChange,
                    this.handleVisibilityChange,
                    false,
                );
                this.isInTab = !document.hidden;
                this.hasBeenInTab = this.isInTab;
            }

            setTimeout(() => {
                this.add_played_extra();
            }, gameSettings.pike.extraTimeout);
        });
    }

    handleVisibilityChange() {
        this.isInTab = !document.hidden;

        if (this.hasBeenInTab) {
            if (!this.isInTab) {
                this.screenExited = true;
            }
        } else {
            this.hasBeenInTab = this.isInTab;
        }
    }

    add_played_extra() {
        if (this.sentextra || this.screenExited) {
            return;
        }
        $.ajax({
            url: links.api.games_played_extra
                .replace("_SK_", window.session_key)
                .replace("_ID_", gameSettings.gameInfo.id),
            cache: false,
        });
    }

    // --- Playtime tracking ---------------------------------------------

    getTrackPlaytimeUrl(duration) {
        const base = links.api.trackplaytime;
        if (base.indexOf("_ID_") !== -1) {
            return base
                .replace("_ID_", gameSettings.gameInfo.id)
                .replace("_SK_", window.session_key)
                .replace("_DURATION_", duration);
        }
        return base + "/" + gameSettings.gameInfo.id + "/" + window.session_key + "/" + duration;
    }

    sendPlaytimeHeartbeat(useBeacon) {
        if (this.playtimeSeconds <= this.playtimeSent) {
            return;
        }
        this.playtimeSent = this.playtimeSeconds;
        const url = this.getTrackPlaytimeUrl(this.playtimeSeconds);
        if (useBeacon && navigator.sendBeacon) {
            navigator.sendBeacon(url);
        } else {
            $.ajax({ url, cache: false });
        }
    }

    flushPlaytime() {
        this.sendPlaytimeHeartbeat(true);
    }

    handlePlaytimeVisibilityChange() {
        if (document.hidden) {
            this.flushPlaytime();
        }
    }

    startPlaytimeTracking() {
        if (this.playtimeTickHandle) {
            return;
        }

        this.playtimeTickHandle = setInterval(() => {
            if (!document.hidden) {
                this.playtimeSeconds += 1;
                if (this.playtimeSeconds % PLAYTIME_HEARTBEAT_SECONDS === 0) {
                    this.sendPlaytimeHeartbeat(false);
                }
            }
        }, 1000);

        document.addEventListener(
            "visibilitychange",
            this.handlePlaytimeVisibilityChange,
            false,
        );
        window.addEventListener("pagehide", this.flushPlaytime);
        window.addEventListener("beforeunload", this.flushPlaytime);
    }

    stopPlaytimeTracking() {
        if (this.playtimeTickHandle) {
            clearInterval(this.playtimeTickHandle);
            this.playtimeTickHandle = null;
        }
        document.removeEventListener(
            "visibilitychange",
            this.handlePlaytimeVisibilityChange,
            false,
        );
        window.removeEventListener("pagehide", this.flushPlaytime);
        window.removeEventListener("beforeunload", this.flushPlaytime);
        this.flushPlaytime();
    }
}

export default GamesPlayedHelper;
